import { defineMessages } from 'react-intl';

const messages = defineMessages({
  paginationLabel: {
    id: 'pgn.DataTable.paginationLabel',
    defaultMessage: 'table pagination',
    description: 'Accessibile name for the navigation element of a pagination component',
  },
  filtersDropdownTitle: {
    id: 'pgn.DataTable.filtersDropdownTitle',
    defaultMessage: 'Filters',
    description: 'Title of the filters dropdown',
  },
});

export default messages;
